import { TRootState } from 'Redux/Reducers';

export const getUserTicketCount = (state: TRootState) => state.userTicket.maxCount;
